import { render, staticRenderFns } from "./Videos.vue?vue&type=template&id=e0a5f2ec&scoped=true&"
import script from "./Videos.vue?vue&type=script&lang=ts&"
export * from "./Videos.vue?vue&type=script&lang=ts&"
import style0 from "./Videos.vue?vue&type=style&index=0&id=e0a5f2ec&lang=postcss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e0a5f2ec",
  null
  
)

export default component.exports